import type { ZapiPath } from '@weft/zapi-types';
import { PATH_ACCESS_LEVELS } from '@weft/zapi-types';
import { NEST_API_TAGS } from '../../api-tags';
import { UPDATE_CONTRACT_PATH_PARAMS } from '../contract-id-path';

export const REVISE_CONTRACT_PATH = {
  accessLevel: PATH_ACCESS_LEVELS.PRIVATE,
  route: '/contract/revise/{contractId}',
  pathParams:  UPDATE_CONTRACT_PATH_PARAMS,
  tags: NEST_API_TAGS.CONTRACT,
} satisfies ZapiPath;

export type ReviseContractPath = typeof REVISE_CONTRACT_PATH;